module.exports = __webpack_public_path__ + "static/img/scan_code.d038345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scan_code.png
// module id = WtYy
// module chunks = 1